import { ITrustedApplicationModel, TrustedApplicationModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceMethodOptions } from '../types';

export class TrustedApplicationService {

    private static baseUrl: string = '/api/trustedapplication';

    static tags = {
        getNewTrustedApplication: "getTrustedApplication",
        getNewApplicationKey: "getNewApplicationKey",
        updateTrustedApplication: "updateTrustedApplication",
        deleteTrustedApplication: "deleteTrustedApplication"
    }

    /**
     * Get a new Trusted Application
     * @param options
     * @returns Returns requested Trusted Application
     */
    static getNewTrustedApplication = (options?: ServiceMethodOptions): Promise<TrustedApplicationModel> => {
        return trackPromise(new Promise<TrustedApplicationModel>((resolve, reject) => {
            http(`${this.baseUrl}/new`).get<ITrustedApplicationModel>()
                .then((response) => {
                    resolve(new TrustedApplicationModel(response));
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.getNewTrustedApplication)
    }

    /**
     * Get a new Application Key
     * @param options
     * @returns Returns new Application Key
     */
    static getNewApplicationKey = (options?: ServiceMethodOptions): Promise<string> => {
        return trackPromise(new Promise<string>((resolve, reject) => {
            http(`${this.baseUrl}/newapplicationkey`).get<string>()
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.getNewApplicationKey)
    }

    /**
     * Updates Trusted Application
     * @param data TrustedApplicationModel to update
     * @param options Service Method Options
     * @returns TrustedApplicationModel
     */
    static upsertTrustedApplication = (data: TrustedApplicationModel, options?: ServiceMethodOptions): Promise<TrustedApplicationModel> => {
        return trackPromise(new Promise<TrustedApplicationModel>((resolve, reject) => {
            http(`${this.baseUrl}`).post<ITrustedApplicationModel>(data)
                .then((response) => {
                    resolve(new TrustedApplicationModel(response));
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.updateTrustedApplication);
    }

    /**
     * Deletes Trusted Application by Id
     * @param id Trusted Application Id
     * @param options Service Method Options
     * @returns boolean on success
     */
    static deleteTrustedApplication = (id: number, options?: ServiceMethodOptions): Promise<boolean> => {
        return trackPromise(new Promise<boolean>((resolve, reject) => {
            http(`${this.baseUrl}/${id}`).delete()
                .then(() => {
                    resolve(true);
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.deleteTrustedApplication);
    }
}
